// ============================================
// « PAS UNE DEMANDE SAV »
// ============================================
// Demande de Nathan du 14/10/2026 : un dossier ouvert par un e-mail qui n'est
// pas une demande SAV (notification, prospection, fournisseur…) se clôt d'un
// geste depuis la fiche. Le serveur (POST /admin/tickets/:id/hors-sav, aussi
// /tickets/:id/hors-sav) clôt avec ce motif, sans aucune notification au
// client, ni relance, ni automatisation, et le trace dans l'historique
// (statut, avec la raison en métadonnée). Réponse : { id, ticketRef,
// status: 'CLOSED', horsSav: true, dejaClos }.

import { AdminApi } from '../../services/api';

export const LIBELLE_HORS_SAV = 'Pas une demande SAV';

/** Le bouton s'affiche sur un dossier qui n'est pas déjà clos. */
export function horsSavPossible(dossier: unknown): boolean {
  if (typeof dossier !== 'object' || dossier === null) return false;
  const d = dossier as { id?: unknown; status?: unknown };
  return typeof d.id === 'string' && d.id !== '' && d.status !== 'CLOSED';
}

/** Texte de la confirmation : ce qui se passe, et surtout ce qui ne part pas. */
export const TEXTE_CONFIRMATION_HORS_SAV =
  'Le dossier sera clos avec le motif « Pas une demande SAV ». Aucun message ne part au client : '
  + 'ni e-mail, ni notification, ni relance. La décision est tracée dans l’historique du dossier.';

export const AVIS_HORS_SAV = 'Dossier clos : pas une demande SAV. Aucun message n’a été envoyé au client.';

/**
 * Envoie la décision. Rend les champs à fusionner dans le dossier affiché :
 * au minimum `status: 'CLOSED'`, plus ce que le serveur renvoie du dossier.
 */
export async function marquerHorsSav(ticketId: string): Promise<Record<string, unknown>> {
  const r = await AdminApi.marquerHorsSav(ticketId);
  const brut = typeof r === 'object' && r !== null ? r as Record<string, unknown> : {};
  // Seuls les champs du dossier sont repris (pas un éventuel { success, data }).
  const dossier = typeof brut.ticket === 'object' && brut.ticket !== null ? brut.ticket as Record<string, unknown> : brut;
  const maj: Record<string, unknown> = {};
  for (const cle of ['status', 'closedAt', 'resolvedAt', 'updatedAt', 'horsSav', 'spamPossible']) {
    if (cle in dossier) maj[cle] = dossier[cle];
  }
  return { ...maj, status: 'CLOSED' };
}
